function getSizeByZoom(zoom,size){
  return size * 100 / zoom;
}

export default getSizeByZoom;